import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { isMobile } from "react-device-detect";
import AppConfig from '../../AppConfig';
import Chapters from '../../components/svg-icons/Chapters';
import * as Actions from '../../store/actions';
import * as HeaderActions from '../../store/actions/header-actions';
import {
  toggleControlsHover,
  hideControls,
} from '../../store/actions/controls-visibility-actions';
// import Hammer from 'hammerjs';

import {
  getBookTitle,
  getViewMode,
  getIsWidget,
  getLinkToBook,
  getIsStarted,
  getGalleryVisibility,
  getBookType,
  getIsAudioBook
} from '../../store/selectors/selectors';

import { IconButton, ICON_TYPE } from '../../components/font-icons/IconButton';
import './style.scss';
import logo from '../../assets/logo.png'

class TopToolbar extends Component {
  constructor() {
    super();
    this.state = {
      isSharePopupVisible: false,
      isTextSettingsVisible: false
    };
  }

  componentDidMount() {
    if (this.props.viewMode === 'text') {
      // this.hammer = new Hammer(document.getElementById('main-header-text'));
      // this.hammer.on("swipeleft", this.props.textSwipeLeft);
      // this.hammer.on("swiperight", this.props.textSwipeRight);
    }
  }

  componentWillUnmount() {
    if (this.props.viewMode === 'text') {
      // this.hammer.off('swipeleft', this.props.textSwipeLeft);
      // this.hammer.off('swiperight', this.props.textSwipeRight);
    }
  }
  /* END Dublicate code from text-player - quick hack */

  onPressTextSettings = () => {
    this.props.toggleTextSettings(true);
    this.props.hideControls();
    this.setState((state) => ({
      isTextSettingsVisible: !state.isTextSettingsVisible
    }));
  }


  onToggleSharePopup = () => {
    this.setState((state) => {
      return { isSharePopupVisible: !state.isSharePopupVisible }
    });
  }

  handleMouseEnter = () => {
    if (!isMobile) {
      this.props.toggleControlsHover(true)
    }
  }

  handleMouseLeave = () => {
    if (!isMobile) {
      this.props.toggleControlsHover(false)
    }
  }

  handleToggleNavGallery = () => {
    this.props.toggleGalleryVisibility()
  }

  render() {
    const {
      bookTitle,
      viewMode,
      isControlsHidden,
      isPlayerStarted,
      isGalleryShown,
      isWidget,
      bookType,
      isAudioBook,
    } = this.props;


    let isHeaderHidden = isGalleryShown || isControlsHidden;



    return (
      <div
        className={cx(
          'main-header',
          {
            'main-header--is-hidden': // скрываем если
              (!isWidget && !isPlayerStarted) || // не виджет и неначинал играть
              (isPlayerStarted && isHeaderHidden)// или уже начинал играть и надо скрыть
          }
        )}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >

        <div className="main-title-viewer">
          <h2>
            {isWidget
              ? <a href={this.props.linkToBook} target="_blank">
                <img src={logo} alt="Cine-Book.com" />
                <span>
                  {bookTitle}
                </span>
              </a>

              : bookTitle
            }
          </h2>
        </div>

        {isPlayerStarted &&

          <div className="header-controls" id="toolbar-header-controls">
            {bookType !== AppConfig.BOOK_TYPES.FILM && !isAudioBook &&
              <div className="control">
                <IconButton
                  type={ICON_TYPE.GALLERY}
                  onClick={this.handleToggleNavGallery}
                />
              </div>
            }
            {isAudioBook &&
            <div
              className="control"
              onClick={this.handleToggleNavGallery}
            >
              <Chapters/>
            </div>
            }

            {viewMode === 'text' &&
              <div className="control">
                <IconButton
                  type={ICON_TYPE.FONT}
                  onClick={this.onPressTextSettings}
                />
              </div>
            }
            {/* <div className="control bookmark-control">
              <IconButton
                type={ICON_TYPE.BOOKMARK}
                onClick={() => { }}
              />
            </div> */}
            {/* <div className="control share-control">
              <IconButton
                type={ICON_TYPE.SHARE}
                onClick={() => {this.onToggleSharePopup()}}
              />
            </div> */}
          </div>
        }
        <div className="share-popup" style={this.state.isSharePopupVisible ? { display: 'flex' } : { display: 'none' }}>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.PINTEREST}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.GOOGLE_PLUS}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.YOUTUBE}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.EMAIL}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.GITHUB}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.TUMBLR}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.FACEBOOK}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.LINKEDIN}
              onClick={() => { }}
            />
          </div>
          <div className="control">
            <IconButton
              type={ICON_TYPE.SOCIAL.TWITTER}
              onClick={() => { }}
            />
          </div>
        </div>
      </div>
    );
  }
}

TopToolbar.defaultProps = { visibility: true };

const mapStateToProps = (state) => {
  const {
    textReader,
    controlsState,
  } = state;
  return {
    isWidget: getIsWidget(state),
    bookTitle: getBookTitle(state),
    linkToBook: getLinkToBook(state),
    viewMode: getViewMode(state),
    isPlayerStarted: getIsStarted(state),
    isControlsHidden: !controlsState.isVisible || textReader.isSlideZoomed,
    isGalleryShown: getGalleryVisibility(state),
    bookType: getBookType(state),
    isAudioBook: getIsAudioBook(state),
  }
};

const actionCreators = {
  ...Actions,
  ...HeaderActions,
  toggleControlsHover,
  hideControls
}
export default connect(mapStateToProps, actionCreators)(TopToolbar)


// WEBPACK FOOTER //
// ./src/containers/top-toolbar/TopToolbar.jsx